import React from 'react';
import { useAppSelector } from '../../../shared/hooks/use-app-selector';

import { TrialDaysNotification } from './TrialDaysNotification';
import { OverdueInvoicesNotification } from './OverdueInvoicesNotification';

export function UserActionNotifications() {
  const currentMerchant = useAppSelector((state) => state.currentMerchant);
  const { subscriptionActivationAllowed } = currentMerchant;

  return (
    <>
      {subscriptionActivationAllowed && <TrialDaysNotification />}
      <OverdueInvoicesNotification />
    </>
  );
}
